import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { Ndc9CodeFormField } from './formFields/Ndc9CodeFormField';

export const Ndc9ProdForm = ({ entityId }) => {

  const augFieldDefs = (fieldToFieldDef) => {

    // Ndc9 Code has a special form field that handles it's Labeler as well
    delete fieldToFieldDef.labelerId;
    fieldToFieldDef.code.component = <Ndc9CodeFormField key="code" fieldDef={fieldToFieldDef.code}/>;

    // Add validator to acqDate
    fieldToFieldDef.acqDate.validators = [(value, formValues) => {
      const marketEntryDate = formValues.marketEntryDate;
      if (value && marketEntryDate && value < marketEntryDate) {
        return 'Acquisition Date must come after Market Entry Date'
      }

      return null;
    }]

    // Add validator to divestDate
    fieldToFieldDef.divestDate.validators = [(value, formValues) => {
      const marketEntryDate = formValues.marketEntryDate;
      if (value && marketEntryDate && value < marketEntryDate) {
        return 'Divestiture Date must come after Acquisition Date'
      }

      return null;
    }]
  }

  return (
    <EntityForm entity="NDC9_PROD" entityId={entityId} augFieldDefs={augFieldDefs}/>
  )
}